import React, { useEffect } from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import SectionHeading from "../common/SectionHeading";
import { useDispatch, useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";
import { setActiveSection } from "../../reducers/slices/navSlice";
import { experience } from "../../data/SkillsData";

const Eductaion = () => {
  const dispatch = useDispatch();
  const { ref, inView } = useInView({ threshold: 0.5 });
  const { timeOfLastClick } = useSelector((state) => state.activeSec);
  const currentTheme = localStorage.getItem("theme") || "dark";

  useEffect(() => {
    if (inView && Date.now() - timeOfLastClick > 1000) {
      dispatch(setActiveSection("experience"));
    }
  }, [inView]);

  return (
    <section ref={ref} className="relative w-full scroll-mt-20 py-20" id="experience">
      <SectionHeading text="Experience" />
      
      <div className="relative w-full py-12 overflow-hidden mt-8">
        {/* Subtle Background Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent-primary/10 blur-[120px] rounded-full pointer-events-none z-0"></div>

        <div className="w-[95%] max-w-[1260px] mx-auto relative z-20">
          <VerticalTimeline className="w-full" lineColor={currentTheme === "light" ? "#e5e7eb" : "rgba(255,255,255,0.1)"}>
            {experience.map((el, index) => (
              <ExperienceItem data={el} key={index} currentTheme={currentTheme} />
            ))}
          </VerticalTimeline>
        </div>
      </div>
    </section>
  );
};

const ExperienceItem = ({ data, currentTheme }) => {
  const isLight = currentTheme === "light";
  
  return (
    <VerticalTimelineElement
      className="vertical-timeline-element--work"
      contentStyle={{
        background: isLight ? "rgba(255, 255, 255, 0.7)" : "rgba(255, 255, 255, 0.03)",
        boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(16px)",
        border: `1px solid ${isLight ? "rgba(0,0,0,0.05)" : "rgba(255,255,255,0.1)"}`,
        borderRadius: "1.5rem",
        padding: "2rem",
        color: isLight ? "#1f2937" : "rgba(255, 255, 255, 0.85)"
      }}
      contentArrowStyle={{ 
        borderRight: `0.5rem solid ${isLight ? "rgba(255, 255, 255, 0.7)" : "rgba(255, 255, 255, 0.03)"}` 
      }}
      date={data.date}
      dateClassName={isLight ? "text-gray-600 font-medium opacity-100" : "text-gray-400 font-medium opacity-100"}
      iconStyle={{ 
        background: isLight ? "#ffffff" : "#050505", 
        color: isLight ? "#6366f1" : "rgba(255,255,255,0.9)",
        border: `2px solid ${isLight ? "#e5e7eb" : "rgba(255,255,255,0.1)"}`,
        boxShadow: "0 0 15px rgba(99, 102, 241, 0.3)"
      }}
      icon={data.icon}
    >
      <h3 className="text-xl font-bold font-Outfit tracking-tight mb-1">{data.heading}</h3>
      <h4 className="text-accent-primary font-semibold mb-4 text-sm uppercase tracking-wider">{data.subHeading}</h4>
      <p className="!font-normal !mt-0 !text-[15px] opacity-80 leading-relaxed">
        {data.desc}
      </p>
    </VerticalTimelineElement>
  );
};

export default Eductaion;
